export default "__VITE_ASSET__DgyxPfCg__"